export default __webpack_public_path__ + "fonts/overview_1.32f37f12c71c878256f536c82a9b29e1.png";